<template>
  <div class="main-wrapper">
    <div class="container">
      <div class="invoice-wrapper index-four">
        <div class="inv-content">
          <div class="invoicenine-header">
            <div class="invoice-header">
              <div class="inv-header-left">
                <a href="javascript:;">
                  <img src="@/assets/img/logo2.png" alt="Logo" />
                </a>
              </div>
              <div class="inv-header-right">
                <div class="invoice-title">TAX INVOICE</div>
              </div>
            </div>
            <div class="company-details">
              <span class="company-name invoice-title">Dreamguys</span>
              <div class="company-content">
                <div class="company-content-left">
                  <div class="company-info">
                    <div class="gst-details">GST IN: <span>22AABCU9603R1ZX</span></div>
                    <div class="gst-details me-0">
                      Mobile: <span>+ 91 98765 43210</span>
                    </div>
                  </div>
                  <div class="gst-details company-address mb-0 me-0">
                    Address:
                    <span>5 Hodges Mews, High Wycombe HP12 3JL, United Kingdom</span>
                  </div>
                </div>
                <div class="inv-header-right">
                  <div class="inv-details">
                    <div class="inv-date">Invoice No: <span>00001</span></div>
                    <div class="inv-date mb-0">Date: <span>5/12/2022</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="invoice-address">
            <div class="invoice-to">
              <span>Bill To:</span>
              <div class="inv-to-address">
                Walter Roberson<br />
                299 Star Trek Drive, Panama City, <br />
                Florida, 32405, USA.<br />
                walter@example.com <br />
                +45 5421 4523
              </div>
            </div>
            <div class="invoice-to">
              <span>Ship To:</span>
              <div class="inv-to-address">
                Lowell H. Dominguez<br />
                84 Spilman Street, London<br />
                United King<br />
                domlowell@example.com<br />
                +45 5421 2154
              </div>
            </div>
          </div>
          <div class="invoice-table">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th class="table_width_1">#</th>
                    <th class="table_width_2">Item</th>
                    <th class="table_width_3">Tax Value</th>
                    <th class="table_width_1 text-center">Qty</th>
                    <th class="table_width_4 text-end">Price</th>
                    <th class="table_width_4 text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td class="">Website Design</td>
                    <td class="table-description">
                      Four plus web pages design and two rivision
                    </td>
                    <td class="text-center">1</td>
                    <td class="text-end">$350</td>
                    <td class="text-end">$350</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="">Web Development</td>
                    <td class="table-description">Dynamic frontend design</td>
                    <td class="text-center">1</td>
                    <td class="text-end">$600</td>
                    <td class="text-end">$600</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td class="">App Development</td>
                    <td class="table-description">Android and Ios App design</td>
                    <td class="text-center">2</td>
                    <td class="text-end">$200</td>
                    <td class="text-end">$400</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td class="">Digital Marketing</td>
                    <td class="table-description">Facebook and instagram marketing</td>
                    <td class="text-center">3</td>
                    <td class="text-end">$100</td>
                    <td class="text-end">$300</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes">
              <span>Important Note:</span>
              <div class="delivery-notes">
                Delivery dates are not guaranteed and Seller has no liability for damages
                that may be incurred due to any delay.
              </div>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>Taxable Amount</td>
                    <td>$1650.00</td>
                  </tr>
                  <tr>
                    <td>Discount</td>
                    <td>+ $0.00</td>
                  </tr>
                  <tr>
                    <td>GST 18.0%</td>
                    <td>$165.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer totalamount-footer">
            <div class="table-footer-left">
              <p class="total-info">Total Items / Qty : 4 / 4.00</p>
            </div>
            <div class="table-footer-right">
              <table class="totalamt-table">
                <tbody>
                  <tr>
                    <td>Total</td>
                    <td>$1815</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="total-amountdetails">
            <p>
              Total amount ( in words):
              <span> $ One Thousand Eight Hundred Fifteen Only.</span>
            </p>
          </div>
          <div class="bank-details">
            <div class="payment-info">
              <span class="payment-title">Payment Info:</span>
              <div><span>Debit Card :</span> 465 *************645</div>
              <div><span>Amount :</span> $1,815</div>
            </div>
            <div class="company-sign">
              <span>For Dreamguys</span>
              <img src="@/assets/img/signature.png" alt="" />
            </div>
          </div>
          <div class="terms-condition">
            <span>Terms and Conditions:</span>
            <ol>
              <li>Goods Once sold cannot be taken back or exchanged</li>
              <li>
                We are not the manufactures, company will stand for warrenty as per their
                terms and conditions.
              </li>
            </ol>
          </div>
          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
